var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _circle, _path16, _path17, _path18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStudying(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m512 256.27c0 .32 0 .64-.01.96 0 .94-.01 1.87-.03 2.8 0 .38-.01.75-.02 1.12-.05 2.48-.13 4.95-.26 7.41-.01.24-.02.48-.03.72-.03.76-.07 1.51-.12 2.27-.01.18-.02.35-.04.53-.26 4.37-.64 8.7-1.13 13.01-.44 3.89-.97 7.76-1.58 11.59-16.39 102.64-93.78 184.91-193.81 208.49-4.84 1.14-9.74 2.15-14.68 3.01-1.2.21-2.4.41-3.61.6-8.26 1.32-16.66 2.25-25.18 2.74-.14.01-.29.02-.43.02-.61.05-1.21.08-1.82.11-.62.04-1.24.07-1.86.1-.33.01-.67.03-1 .04-.88.04-1.75.07-2.63.1-2.67.08-5.35.11-8.03.11-1.35 0-2.69-.01-4.03-.04-3.97-.06-7.91-.21-11.83-.46-2.17-.14-4.34-.3-6.5-.49-4.86-.42-9.68-.99-14.46-1.69-.05-.01-.09-.01-.14-.02-1.54-.22-3.08-.46-4.61-.71-2.75-.45-5.48-.94-8.2-1.48-.23-.05-.47-.09-.7-.14-12.93-2.6-25.49-6.17-37.62-10.63-3.52-1.3-7-2.67-10.45-4.12-92.42-38.69-157.3-130.04-157.19-236.49.15-141.38 114.89-255.88 256.27-255.73 119.06.13 219.06 81.51 247.56 191.64.34 1.33.68 2.66 1 4 .7 2.89 1.35 5.79 1.95 8.72.39 1.93.77 3.87 1.11 5.82.12.58.22 1.16.32 1.74 1.13 6.46 2.01 13.01 2.63 19.63.01.06.01.11.02.17.31 3.32.56 6.66.75 10.01v.01c.01.25.03.49.04.74.04.87.08 1.75.12 2.62.16 3.7.23 7.43.23 11.17z",
    fill: "#3bc3ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m512 256.27c0 .32 0 .64-.01.96 0 .94-.01 1.87-.03 2.8 0 .38-.01.75-.02 1.12-.05 2.48-.13 4.95-.26 7.41-.01.24-.02.48-.03.72-.03.76-.07 1.51-.12 2.27-.01.18-.02.35-.04.53-.26 4.37-.64 8.7-1.13 13.01-.44 3.89-.97 7.76-1.58 11.59-16.39 102.64-93.78 184.91-193.81 208.49-4.84 1.14-9.74 2.15-14.68 3.01-1.2.21-2.4.41-3.61.6-8.26 1.32-16.66 2.25-25.18 2.74-.14.01-.29.02-.43.02-.61.05-1.21.08-1.82.11-.62.04-1.24.07-1.86.1-.33.01-.67.03-1 .04-.88.04-1.75.07-2.63.1-2.67.08-5.35.11-8.03.11-1.35 0-2.69-.01-4.03-.04-41.95-41.8-128.45-128.11-128.45-128.11l-.32-68.1-14.19-13.77 17.4-26.48v-25.42l-17.4-16.95 63.55-26.48v-26.07l-.08-.01.08-.02-59.39-59.3h288.23l109.71 110.3c.01.06.01.11.02.17.31 3.32.56 6.66.75 10.01v.01c.01.25.03.49.04.74.04.87.08 1.75.12 2.62.16 3.7.23 7.43.23 11.17z",
    fill: "#09a1e8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m172.284 131.631h169.469v98.384h-169.469z",
    fill: "#225779"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m257.019 131.631h84.734v98.384h-84.734z",
    fill: "#063051"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m397.96 177.15h-25.42l-3.178-55.902h31.775z",
    fill: "#225779"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m384.121 384.069h-229.118c-17.949 0-32.5-14.551-32.5-32.5v-3.847c0-17.949 14.551-32.5 32.5-32.5h229.118z",
    fill: "#fff3dc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m257.019 315.222h127.102v68.847h-127.102z",
    fill: "#ebd9be"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m156.397 328.462h248.908v-26.48h-47.663-201.245c-26.282 0-47.663 21.382-47.663 47.663s21.381 47.663 47.663 47.663h248.908v-26.48h-248.908c-11.681 0-21.184-9.503-21.184-21.184 0-11.679 9.503-21.182 21.184-21.182z",
    fill: "#f1444f"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m257.019 370.829h148.285v26.48h-148.285z",
    fill: "#db2835"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m357.641 301.982h-100.622v2.877 23.603h148.285v-26.48z",
    fill: "#db2835"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m126.143 288.743h233.422c17.949 0 32.5-14.551 32.5-32.5v-3.847c0-17.949-14.551-32.5-32.5-32.5h-233.422z",
    fill: "#fff3dc"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m357.641 219.896h-100.622v68.847h100.622c19.011 0 34.423-15.412 34.423-34.423.001-19.012-15.411-34.424-34.423-34.424z",
    fill: "#ebd9be"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m108.734 275.503h248.908c11.681 0 21.184-9.503 21.184-21.184 0-11.68-9.503-21.184-21.184-21.184h-248.908v-26.48h248.908c26.282 0 47.663 21.382 47.663 47.663s-21.381 47.663-47.663 47.663h-248.908z",
    fill: "#ffc43a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m357.641 206.656h-100.622v26.48h100.622c11.681 0 21.184 9.503 21.184 21.184 0 11.68-9.503 21.184-21.184 21.184h-100.622v26.48h100.622c26.282 0 47.663-21.382 47.663-47.663s-21.381-47.665-47.663-47.665z",
    fill: "#fda632"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m257.019 159.448-144.119-38.2 144.119-38.201 144.118 38.201z",
    fill: "#3477a6"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 385.25,
    cy: 187.391,
    fill: "#063051",
    r: 21.184
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m257.019 83.047v76.401l144.119-38.2z",
    fill: "#185f8d"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m219.342 417.774-22.469-13.332-22.47 13.332v-67.41h44.939z",
    fill: "#ffc43a"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m339.087 322.447-22.47-13.331-22.47 13.331v-67.409h44.94z",
    fill: "#3477a6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudying);
export default __webpack_public_path__ + "static/media/studying.01bfc52e9fcb9d428239122cf4192681.svg";
export { ForwardRef as ReactComponent };